/**
 * Campo domanda del modulo BI: TextArea + bottone "Chiedi" + chip di domande-esempio.
 * Solo input: non conosce la rete né i risultati. Chiama onAsk(question) al submit.
 */

import { useState } from 'react'
import { Button, Input, Space, Tag } from 'antd'

const EXAMPLES = [
  'Quante schede di lavoro ci sono per ogni stato?',
  'Quali clienti hanno più schede di lavoro?',
  'Quanti clienti attivi ci sono?',
]

interface AskBoxProps {
  onAsk: (question: string) => void
  loading: boolean
}

function AskBox({ onAsk, loading }: AskBoxProps) {
  const [text, setText] = useState('')

  const submit = () => {
    const q = text.trim()
    if (q) onAsk(q)
  }

  return (
    <Space direction="vertical" style={{ width: '100%' }} size="middle">
      <Input.TextArea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Scrivi una domanda sui tuoi dati, in italiano…"
        autoSize={{ minRows: 2, maxRows: 6 }}
        disabled={loading}
      />
      <Space wrap size={[8, 8]}>
        {EXAMPLES.map((ex) => (
          <Tag key={ex} style={{ cursor: 'pointer' }} onClick={() => setText(ex)}>
            {ex}
          </Tag>
        ))}
      </Space>
      <Button type="primary" onClick={submit} loading={loading} disabled={!text.trim()}>
        Chiedi
      </Button>
    </Space>
  )
}

export default AskBox
